<ng-content select="[~left]"></ng-content>
<ng-content select="[~title]"></ng-content>
<ng-content select="[~right]"></ng-content>

@if (box$ | async; as box) {
  <div
    #backdrop
    moveToRoot
    class="backdrop"
    [class.has-backdrop]="hasBackdrop"
    [class.menu-closing]="isClosing"
    animate.enter="anim-menu-enter-fade"
    [style.z-index]="hasBackdrop ? 100 : 101"
    (click)="close()"
    >
    <div
      #wrapper
      class="wrapper-menu rounded-1.5 shadow-z-menu box-border scrollbar-fade overflow-auto"
      [class.h-full]="fullHeight && !$positionClasses().RIGHT"
      [class.bg-280]="!lightBg"
      [class.bg-180]="lightBg"
      [class.border-solid-line-250]="bordered"
      [class.RIGHT]="$positionClasses().RIGHT"
			[ngClass]="{
				'position-at-top-of-target': box.positionAtTopOfTarget,
				'position-at-left-of-target': box.positionAtLeftOfTarget,
			}"
			[ngStyle]="{
				'--__top.px': box.top,
				'--__bottom.px': box.bottom,
				'--__anchorHeight.px': box.anchorHeight,
				'--__left.px': box.left,
				'--__right.px': box.right,
				'--__anchorWidth.px': box.anchorWidth,
				'--__maxWidth.px': box.maxWidth,
				'--__maxHeight.px': box.maxHeight,
				'--__BASE_WIDTH.px': box.baseWidth,
				'--__BASE_MAX_HEIGHT': maxHeight,
				'min-width.px': box.minWidth,
				'z-index': hasBackdrop ? 100 : 101,
			}"
			(click)="$event.stopPropagation()"
		>
			<div
				class="px-1 pb-1 box-border wrapper-content"
				[class.h-full]="fullHeight"
				[class.pt-1]="hasPaddingTop"
			>
				<ng-content></ng-content>
			</div>
			<ng-content select="[~footer]"></ng-content>
		</div>
	</div>
}
